module.exports = __webpack_public_path__ + "static/img/fail.5643002.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/fail.png
// module id = Y4It
// module chunks = 34